import { Form, Grid, Select } from '@approvalmax/ui/src/components';
import { memo, useMemo } from 'react';

import { legalEntityTypes } from './SecondStep.constants';
import { messages } from './SecondStep.messages';
import { SecondStepProps } from './SecondStep.types';

export const SecondStep = memo<SecondStepProps>((props) => {
    const { requirements } = props;

    const paymentMethods = useMemo(() => {
        if (!requirements) {
            return [];
        }

        return requirements.map((requirement) => {
            return {
                id: requirement.payNetworkName,
                name: requirement.payNetworkName,
            };
        });
    }, [requirements]);

    return (
        <Form.Part>
            <Grid gridTemplateColumns='repeat(2, 1fr)' gap={16}>
                <Select
                    name='paymentMethod'
                    label={messages.paymentMethod}
                    placeholder={messages.selectPlaceholder}
                    items={paymentMethods}
                    required
                    clearable={false}
                    autocomplete
                />

                <Select
                    name='legalEntity.legalEntityType'
                    label={messages.enityType}
                    placeholder={messages.selectPlaceholder}
                    items={legalEntityTypes}
                    required
                    clearable={false}
                    autocomplete
                />
            </Grid>
        </Form.Part>
    );
});

SecondStep.displayName = 'SecondStep';
